import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { FormAuthenticationmessage } from "./FormAuthenticationmessage";
import axios from "axios";
import Swal from "sweetalert2";

const ContactSection4 = () => {
  const validate = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string().required("Email is required"),
    subject: Yup.string(),
    message: Yup.string(),
    requestCall: Yup.string(),
  });

  const inputClass =
    "form-control py-3 border text-[#415674] text-[13px] w-[100%] border-slate-300 mt-2 rounded-md outline-orange-400 px-3";

  return (
    <div>
      <Formik
        initialValues={{
          name: "",
          email: "",
          subject: "",
          message: "",
          requestCall: false,
        }}
        validationSchema={validate}
        onSubmit={async (values, { resetForm }) => {
          try {
            Swal.fire({
              title: "Sending Data",
              text: "Please wait...",
              icon: "info",
              allowOutsideClick: false,
              showConfirmButton: false,
              showCancelButton: false,
              didOpen: () => {
                Swal.showLoading();
              },
            });
            await validate.validate(values, { abortEarly: false });

            resetForm();
            await axios.post("https://api.mbasolutions.co/shortForm", values);

            Swal.fire({
              icon: "success",
              title: "Success!",
              text: "Data has been sent successfully",
            });
          } catch (error) {
            console.error(error);

            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Network Error.Please Try Again Later.",
            });
          }
        }}
      >
        {(formik) => (
          <div>
            <div className="md:w-[56%] w-[92%] mx-auto shadow-xl py-12 md:py-16 mb-20 rounded-3xl bg-white border border-[#f2d7b8]">
              <h1 className="mx-auto max-w-lg px-6 py-5 rounded-xl text-[#1B1C19] text-center shadow-md bg-[#fff8f0] font-bold text-xl md:text-2xl lg:text-3xl">
                Have Any Questions?
              </h1>
              <p className="text-center text-[#4c4d56] mt-4 px-6">
                Send us your message and our team will get back to you shortly.
              </p>

              <Form className="mx-6 md:mx-12 text-[#4c4d56] mt-12">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 md:gap-x-8 w-[100%]">
                  <div className="mb-5">
                    <label
                      htmlFor="name"
                      className="block text-sm font-medium text-[#4c4d56]"
                    >
                      Name
                    </label>
                    <FormAuthenticationmessage
                      type="text"
                      id="name"
                      name="name"
                      className={inputClass}
                      placeholder="Name"
                    />
                  </div>
                  <div className="form-group">
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-[#4c4d56]"
                    >
                      Email
                    </label>
                    <FormAuthenticationmessage
                      type="text"
                      id="email"
                      name="email"
                      className={inputClass}
                      placeholder="Email"
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="subject"
                    className="block text-sm font-medium text-[#4c4d56]"
                  >
                    Subject
                  </label>
                  <FormAuthenticationmessage
                    type="text"
                    id="subject"
                    name="subject"
                    className={`${inputClass} mb-5`}
                    placeholder="Subject"
                  />

                  <label
                    htmlFor="message"
                    className="block text-sm font-medium text-[#4c4d56]"
                  >
                    Message
                  </label>
                  <FormAuthenticationmessage
                    textarea
                    id="message"
                    name="message"
                    className="form-control py-3 flex justify-start items-start min-h-[150px] border text-[#415674] text-[13px] w-[100%] border-slate-300 my-2 rounded-md outline-orange-400 px-3"
                    placeholder="Write your Question"
                  />
                  <div className="flex items-center mt-4">
                    <FormAuthenticationmessage
                      type="checkbox"
                      name="requestCall"
                      className="mr-2 w-4 h-4 accent-orange-500"
                      checked={formik.values.requestCall}
                    />
                    <label className="text-sm text-[#4c4d56]">
                      Request a Call
                    </label>
                  </div>
                  <button
                    className="btn md:w-[160px] hover:shadow-lg bg-orange-500 hover:bg-orange-600 transition-all duration-200 ease-out text-white cursor-pointer mt-6 px-6 py-3 rounded-md text-lg font-semibold"
                    type="submit"
                  >
                    Submit
                  </button>
                </div>
              </Form>
            </div>
          </div>
        )}
      </Formik>
    </div>
  );
};

export default ContactSection4;
